import React from "react";
import Footer from "../Footer/Footer";

const Billing = () => {
  return (
    <>
      <div style={{ height: "100vh" }}>
        <h1 style={{ textAlign: "center", marginTop: "70px" }}>
          This is billing page, will be updated soon...
        </h1>
      </div>
      <Footer />
    </>
  );
};

export default Billing;
